export default __webpack_public_path__ + "c3dcdbd5bb4d4af80817dc0edc1cd888.woff2";